import { AuditType } from './audit-type.enum';

export class AdhocAuditRequest {
  selectedType: AuditType = AuditType.FiveS;
  prevalence = 0;
  areaId = '';
  locationId = '';

  [key: string]: string | number;
}
